// extracted by mini-css-extract-plugin
module.exports = {"content":"_0fce717cdb--content--_Bi5x","icon-wrapper":"_0fce717cdb--icon-wrapper--Unje4","heading":"_0fce717cdb--heading--IqiYP","footer":"_0fce717cdb--footer--M5UrR"};